export * from "./getIsStatusValidated";
